<template>
  <modal title="Edit Payment Method" size="xs" ref="modal">
    <form class="q-gutter-md">
      <q-input label="Label" v-model="label" outlined hint="e.g. Personal, Business" clearable />
    </form>
    <template v-slot:actions>
      <async-btn label="Save" color="primary" :task="task" @click="save" />
    </template>
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import { PaymentMethod, Modal as ModalElement } from '@/type';
import Modal from '@/components/modal/Modal.vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import notify from '@/components/notify';
import { update } from './payment-method';

interface Data {
  label: string,
  task: Promise<PaymentMethod>|null,
}

export default defineComponent({
  emits: ['ok'],
  mixins: [ModalMixin],
  components: {
    Modal,
    AsyncBtn,
  },
  props: {
    paymentMethod: {
      type: Object as () => PaymentMethod,
      required: true,
    },
  },
  data(): Data {
    return {
      label: this.paymentMethod.label || '',
      task: null,
    };
  },
  methods: {
    save() {
      const label = (this.label || '').trim() || null;
      this.task = update(this.paymentMethod.id, label);
      this.task.then((paymentMethod: PaymentMethod) => {
        this.$emit('ok', paymentMethod);
        (this.$refs.modal as ModalElement).hide();
        notify('Payment method updated.');
      });
    },
  },
});
</script>
